import { Box, Skeleton } from '@mui/material'

// IMPORTANT: This skeleton is intentionally kept simple
// because BidLadderContent is in active development and may change
function BidLadderContentSkeleton() {
  return (
    <Box sx={{ p: 2 }}>
      <Skeleton height={400} variant="rectangular" />
    </Box>
  )
}

export default BidLadderContentSkeleton
